export const getScore = (questions, answers) => {
  let score = 0;
  for (let i = 0; i < questions.length; i++) {
    if (
      questions[i] &&
      answers[i] &&
      typeof questions[i] === "string" &&
      typeof answers[i] === "string" &&
      questions[i].toLowerCase() === answers[i].toLowerCase()
    ) {
      score++;
    }
  }
  return score;
};

export const getScoreMCMA = (correctAnswers, selectedAnswers) => {
  const correctSelections = selectedAnswers.filter((answer) =>
    correctAnswers.includes(answer)
  ).length;

  const incorrectSelections = selectedAnswers.filter(
    (answer) => !correctAnswers.includes(answer)
  ).length;

  const score = correctSelections - incorrectSelections;
  return Math.max(0, score);
};

export const getHighlightIncorrectWordsScore = (selectedAnswers, correctAnswers) => {
  const matchedAnswers = selectedAnswers.filter((answer) =>
    correctAnswers.includes(answer)
  );

  const unmatchedAnswers = selectedAnswers.filter(
    (answer) => !correctAnswers.includes(answer)
  );

  let score = matchedAnswers.length - unmatchedAnswers.length;
  return score < 0 ? 0 : score;
};
